export default __webpack_public_path__ + "static/media/remove_tag.2b86fcca.svg";